angular.module("vgresiduos").directive("destinationData", function () {
	return {
		scope: true,
		controller: "DestinationDataCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/baseComponents/destinationData/destinationData_template.html"
	};
});
